// @flow
import * as React from 'react';
import {useLocation} from "react-router-dom";
import {requestDeviceInfo, requestPutDevice} from '../../../../axios/http'
import {Form, Input, InputNumber, message, Popconfirm, Table, Tag, Typography} from 'antd';
import {useEffect, useState} from "react";
import moment from "moment/moment";
import  './index.scss'



type Props = {
    id:number
};


const deviceSchema = {
    'adr': (value: any) => value === 'true' || value === 'false' || value === null, // 处理字符串布尔值
    'app_eui': (value: any) => /^[0-9A-F]{16}$/.test(value) || value === null,
    'app_key': (value: any) => /^[0-9A-F]{32}$/.test(value) || value === null,
    'app_non': (value: any) => !isNaN(parseInt(value)) || value === null, // 转换为整数
    'c_retry': (value: any) => !isNaN(parseInt(value)) || value === null, // 转换为整数
    'class_b': (value: any) => value === 'true' || value === 'false' || value === null, // 布尔值转换
    'class_c': (value: any) => value === 'true' || value === 'false' || value === null, // 布尔值转换
    'd_retry': (value: any) => !isNaN(parseInt(value)) || value === null,
    'des_rx1_delay': (value: any) => !isNaN(parseInt(value)) || value === null,
    'des_rx1_dro': (value: any) => !isNaN(parseInt(value)) || value === null,
    'des_rx2_dr': (value: any) => !isNaN(parseInt(value)) || value === null,
    'des_rx2_freq': (value: any) => !isNaN(parseInt(value)) || value === null,
    'description': (value: any) => typeof value === 'string' || value === null,
    'dev_non': (value: any) => !isNaN(parseInt(value)) || value === null,
    'dutycyle': (value: any) => !isNaN(parseInt(value)) || value === null,
    'enable': (value: any) => value === 'true' || value === 'false' || value === null, // 布尔值转换
    'firmware': (value: any) => !isNaN(parseInt(value)) || value === null,
    'join_type': (value: any) => /^(OTAA|ABP)$/.test(value) || value === null,
    'name': (value: any) => typeof value === 'string' || value === null,
    'net_id': (value: any) => !isNaN(parseInt(value)) || value === null,
    'region': (value: any) => /^(EU868|US915|CN779|EU433|AU915|CN470|AS923_1|AS923_2|AS923_3|KR920|IN865|RU864)$/.test(value) || value === null,
    'rx1_delay': (value: any) => !isNaN(parseInt(value)) || value === null,
    'rx1_dro': (value: any) => !isNaN(parseInt(value)) || value === null,
    'rx2_dr': (value: any) => !isNaN(parseInt(value)) || value === null,
    'rx2_freq': (value: any) => !isNaN(parseInt(value)) || value === null,
    'script_id': (value: any) => !isNaN(parseInt(value)) || value === null,
    'time_zone': (value: any) => !isNaN(parseInt(value)) || value === null,
    'up_confirm': (value: any) => value === 'true' || value === 'false' || value === null, // 布尔值转换
    'up_dr': (value: any) => !isNaN(parseInt(value)) || value === null
};


const deviceChangeSchema = {
    'adr': (value: any) => {
        if (value === 'true') return true;
        if (value === 'false') return false;
        return value === null ? null : undefined;
    },
    'app_eui': (value: any) => /^[0-9A-F]{16}$/.test(value) ? value : null,
    'app_key': (value: any) => /^[0-9A-F]{32}$/.test(value) ? value : null,
    'app_non': (value: any) => !isNaN(parseInt(value)) ? parseInt(value) : null,
    'c_retry': (value: any) => !isNaN(parseInt(value)) ? parseInt(value) : null,
    'class_b': (value: any) => {
        if (value === 'true') return true;
        if (value === 'false') return false;
        return value === null ? null : undefined;
    },
    'class_c': (value: any) => {
        if (value === 'true') return true;
        if (value === 'false') return false;
        return value === null ? null : undefined;
    },
    'd_retry': (value: any) => !isNaN(parseInt(value)) ? parseInt(value) : null,
    'des_rx1_delay': (value: any) => !isNaN(parseInt(value)) ? parseInt(value) : null,
    'des_rx1_dro': (value: any) => !isNaN(parseInt(value)) ? parseInt(value) : null,
    'des_rx2_dr': (value: any) => !isNaN(parseInt(value)) ? parseInt(value) : null,
    'des_rx2_freq': (value: any) => !isNaN(parseInt(value)) ? parseInt(value) : null,
    'description': (value: any) => typeof value === 'string' ? value : null,
    'dev_non': (value: any) => !isNaN(parseInt(value)) ? parseInt(value) : null,
    'dutycyle': (value: any) => !isNaN(parseInt(value)) ? parseInt(value) : null,
    'enable': (value: any) => {
        if (value === 'true') return true;
        if (value === 'false') return false;
        return value === null ? null : undefined;
    },
    'firmware': (value: any) => !isNaN(parseInt(value)) ? parseInt(value) : null,
    'join_type': (value: any) => /^(OTAA|ABP)$/.test(value) ? value : null,
    'name': (value: any) => typeof value === 'string' ? value : null,
    'net_id': (value: any) => !isNaN(parseInt(value)) ? parseInt(value) : null,
    'region': (value: any) => /^(EU868|US915|CN779|EU433|AU915|CN470|AS923_1|AS923_2|AS923_3|KR920|IN865|RU864)$/.test(value) ? value : null,
    'rx1_delay': (value: any) => !isNaN(parseInt(value)) ? parseInt(value) : null,
    'rx1_dro': (value: any) => !isNaN(parseInt(value)) ? parseInt(value) : null,
    'rx2_dr': (value: any) => !isNaN(parseInt(value)) ? parseInt(value) : null,
    'rx2_freq': (value: any) => !isNaN(parseInt(value)) ? parseInt(value) : null,
    'script_id': (value: any) => !isNaN(parseInt(value)) ? parseInt(value) : null,
    'time_zone': (value: any) => !isNaN(parseInt(value)) ? parseInt(value) : null,
    'up_confirm': (value: any) => {
        if (value === 'true') return true;
        if (value === 'false') return false;
        return value === null ? null : undefined;
    },
    'up_dr': (value: any) => !isNaN(parseInt(value)) ? parseInt(value) : null
};




interface Item {
    key: string;
    Parm: string;
    value: number | string;
    type:string
}


const originData: Item[] = [];

interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
    editing: boolean;
    dataIndex: string;
    title: any;
    inputType: 'number' | 'text';
    record: Item;
    index: number;
    children: React.ReactNode;
}

const EditableCell: React.FC<EditableCellProps> = ({
                                                       editing,
                                                       dataIndex,
                                                       title,
                                                       inputType,
                                                       record,
                                                       index,
                                                       children,
                                                       ...restProps
                                                   }) => {
    const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;

    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{ margin: 0 }}
                    rules={[
                        {
                            required: true,
                            message: `Please Input ${title}!`,
                        },
                    ]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};




export const ChildDevice = (props:Props) => {
    let {id} = props
    // const [data, setData] = useState<any>({})
    const [info, setInfo] = useState<any>(originData)
    const [script, setScript] = useState<any>(originData)
    const [form] = Form.useForm();
    const [infoForm] = Form.useForm();
    const [scriptForm] = Form.useForm();
    const [data, setData] = useState(originData);
    const [editingKey, setEditingKey] = useState('');

    const isEditing = (record: Item) => record.key === editingKey;

    const edit = (record: Partial<Item> & { key: React.Key }) => {
        if( record.type === 'info'){
            infoForm.setFieldsValue({ Parm: '', value: '', type: '', ...record });
        }else if(record.type === 'script'){
            scriptForm.setFieldsValue({ Parm: '', value: '', type: '', ...record });
        }else {
            form.setFieldsValue({ Parm: '', value: '', type: '', ...record });
        }

        setEditingKey(record.key);
    };

    const cancel = () => {
        setEditingKey('');
    };

    const save = async (key: React.Key, record:any) => {
        try {
            let obj = record.type === 'info' ? infoForm :  record.type === 'script' ? scriptForm : form
            const row = (await obj.validateFields()) as Item;

            let newData = [];
            if( record.type === 'info'){
                newData = [...info];
            }else if(record.type === 'script'){
                newData = [...script];
            }else {
                newData = [...data];
            }
            const index = newData.findIndex(item => key === item.key);
            if (index > -1) {
                const item = newData[index];
                let parm = {
                    ...item,
                    ...row,
                }
                if(!deviceSchema.hasOwnProperty(parm.Parm)){
                    message.error('该参数不支持更改')
                    return
                }

                // @ts-ignore
                if(!deviceSchema[String(parm.Parm)](parm.value)){
                    message.error('参数格式有误')
                    return
                }
                requestPutDevice(Number(id),{
                    // @ts-ignore
                    [parm.Parm]:deviceChangeSchema[parm.Parm](parm.value)
                }).then(()=>{
                    message.success('修改成功')
                }).catch(()=>{
                    message.error('修改失败')
                })

                newData.splice(index, 1, parm);
                if( record.type === 'info'){
                    setInfo(newData)
                }else if(record.type === 'script'){
                    setScript(newData)
                }else {
                    setData(newData);
                }

                setEditingKey('');
            } else {
                if( record.type === 'info'){
                    newData.push(row);
                    setInfo(newData)
                }else if(record.type === 'script'){
                    newData.push(row);
                    setScript(newData)
                }else {
                    newData.push(row);
                    setData(newData);
                }
                setEditingKey('');
            }
        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    };


    const columns = [
        {
            title: 'Parm',
            dataIndex: 'Parm',
            width: '25%',
            editable: false,
        },
        {
            title: 'value',
            dataIndex: 'value',
            width: '15%',
            editable: true,
        },
        {
            title: 'operation',
            dataIndex: 'operation',
            render: (_: any, record: Item) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
            <Typography.Link onClick={() => {

                save(record.key, record)
            }} style={{ marginRight: 8 }}>
              Save
            </Typography.Link>
            <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
              <a>Cancel</a>
            </Popconfirm>
          </span>
                ) : (
                    <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
                        Edit
                    </Typography.Link>
                );
            },
        },
    ];


    const mergedColumns = columns.map(col => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record: Item) => ({
                record,
                inputType: col.dataIndex === 'age' ? 'number' : 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    
    
    function changeValue(obj:any,text: string) {
        if(text === 'enable'){
            return obj.enable ? 'enable' : 'Not enable'
        }else if(text === 'online'){
           return   obj.online ? 'online' : 'Disconnection'
        }else if(text === 'active_time'){
            return   obj.active_time && moment(obj.active_time).format('YYYY-MM-DD HH:mm:ss')
        }else if(text === 'create_time'){
            return   obj.create_time && moment(obj.create_time).format('YYYY-MM-DD HH:mm:ss')
        }else if(text ==='modify_time'){
            return   obj.modify_time && moment(obj.modify_time).format('YYYY-MM-DD HH:mm:ss')
        }else if(text ==='creator'){
            return   obj.creator.username
        } else {
            return obj[text]
        }
        
    }

    async function getInfo() {
        let result = await  requestDeviceInfo(id) as  any

        let arr = Object.keys(result.data)
        let infoList:Item[] = []
        let scriptList:Item[] = []
        const list = arr
            .map((item: any, index: number) => {
                if (item !== 'info' && item !== 'script') {
                    return {
                        key: String(index),
                        Parm: item,
                        value:changeValue(result.data, item),
                        type:'data'
                    };
                }
                return undefined; // 返回 undefined，当元素不需要时
            })
            .filter((item): item is {type: string; key: string; Parm: any; value: any } => item !== undefined);

        if(result.data.info !== null){
            infoList = Object.keys(result.data.info)
                .map((item: any, index: number) => {
                    if (item !== 'info' && item !== 'script') {

                        return {
                            key: String(list.length + index),
                            Parm: item,
                            value:changeValue(result.data.info, item),
                            type:'info'
                        };
                    }
                    return undefined; // 返回 undefined，当元素不需要时
                })
                .filter((item): item is {type: string; key: string; Parm: any; value: any } => item !== undefined);

        }


        if(result.data.script !== null){
            scriptList = Object.keys(result.data.script)
                .map((item: any, index: number) => {
                    if (item !== 'info' && item !== 'script' && item !== 'map') {

                        return {
                            key: String(infoList.length + list.length + index),
                            Parm: item,
                            value:changeValue(result.data.script, item),
                            type:'script'
                        };
                    }
                    return undefined; // 返回 undefined，当元素不需要时
                })
                .filter((item): item is {type: string; key: string; Parm: any; value: any } => item !== undefined);
            result.data.script.map.forEach((item : any,index:number)=>{

                scriptList.push({
                    key: String(list.length + scriptList.length + infoList.length + index),
                    Parm: `${item.name} (map)`,
                    value:`id: ${item.id} unit: ${item.unit}`,
                    type:'script'
                })
            })

        }

        setData(list)
        setInfo(infoList)
        setScript(scriptList)
    }

    useEffect(() => {
        getInfo()
    }, []);



    return (
        <div>
            <div className='deviceInfo'>
                <Form form={form} component={false}>
                    <Table
                        components={{
                            body: {
                                cell: EditableCell,
                            },
                        }}
                        bordered
                        dataSource={data}
                        columns={mergedColumns}
                        rowClassName="editable-row"
                        pagination={{
                            onChange: cancel,
                        }}
                    />
                </Form>
            </div>
            {
                !!info.length &&  <div className='deviceInfo'>
                    <Form form={infoForm} component={false}>
                        <Table
                            components={{
                                body: {
                                    cell: EditableCell,
                                },
                            }}
                            bordered
                            dataSource={info}
                            columns={mergedColumns}
                            rowClassName="editable-row"
                            pagination={{
                                onChange: cancel,
                            }}
                        />
                    </Form>
                </div>
            }
            {
                !!script.length && <div className='deviceInfo'>
                    <Form form={scriptForm} component={false}>
                        <Table
                            components={{
                                body: {
                                    cell: EditableCell,
                                },
                            }}
                            bordered
                            dataSource={script}
                            columns={mergedColumns}
                            rowClassName="editable-row"
                            pagination={{
                                onChange: cancel,
                            }}
                        />
                    </Form>
                </div>
            }
        </div>
    );
};